import React from 'react';
import { useTranslation } from "react-i18next";
import { useForm } from '../../../hooks/useForm';
import  { useStore } from '../hooks/useStore';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import { ActionButtons } from '../../../components/others/ActionButtons';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { StoreForm } from '../components/StoreForm';
import { Products } from '../components/Products';

const initialState = {
    type: '',
    type_responsible: '',
    responsible: '',
    type_document: '',
    document: '',
    observation: '',
    warehouse: '',
    dateOfEntry: new Date().toISOString(),
    products: []
}

export const StoreLayout = () => {
    const { t } = useTranslation();
    const [values,
        handleInputChange,
        handleDirectInputChange,
        setAllInfo] = useForm(initialState);
    const productsFormRef = React.useRef();
    const formRef = React.useRef();
    const {
        loading,
        isView,
        companies,
        openDialogCompany,
        handleSubmit,
        handleCancel,
        handleConfirmAction
    } = useStore({
        values,
        setAllInfo,
        handleDirectInputChange,
        formRef,
        productsFormRef,
        t
    });

  return (
    <Box sx={{ width: '90%', mx: 'auto' }}>
        <Typography variant="h4" gutterBottom>
            {t('warehouse.RegistryStore')}
        </Typography>

        <Card sx={{ mb: 3 }}>
            <CardContent>
                <StoreForm 
                    ref={formRef}
                    dto={values}
                    handleInputChange={handleInputChange}
                    handleDirectInputChange={handleDirectInputChange}
                    isView={isView}
                />
                {values.products.length > 0 && (
                    <Box sx={{ mt: 4 }}>
                        <DividerGradient />
                        <Products 
                            ref={productsFormRef}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={values}
                            isView={isView}
                        />
                    </Box>
                )}
                <ActionButtons
                    onCancel={handleCancel}
                    onSubmit={handleSubmit}
                    submitLabel={t('save')}
                    disabledSubmit={isView}
                />
            </CardContent>
        </Card>
        <DialogSelectCompany
            openDialogConfirm={openDialogCompany}
            handleCancelConfirm={handleCancel}
            handleConfirmAction={handleConfirmAction}
            data={companies}
        />
        <LoadingOverlay isOpen={loading} />
    </Box>
  )
}
